import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from '../locales/en'
import usLocal from '../locales/zh-CN'
Vue.use(VueI18n)
const messages = {
  en: {
    ...enLocale
  },
  cn: {
    ...usLocal
  }
}
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'cn',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/js/i18n.js